import { Button, Grid } from '@material-ui/core'
import { AccessAlarmOutlined } from '@material-ui/icons'
import * as React from 'react'

import map from '../../assets/map.png'
import { buttonsStyles } from '../../styles/ButtonsStyles'
import { containerStyles } from '../../styles/ContainerStyles'
import { textStyles } from '../../styles/TextStyles'
import { formatTimeline } from '../../utils/helper'
import { showMessage } from '../../utils/notification'
import { PuzzleHeaderDto } from '../../utils/types'
import { SectionTitle } from '../atoms/SectionTittle'
import { PuzzleCardView } from '../molecules/PuzzleCardsView'

interface Props {
    maxSlots: number
    minSlots: number
    availablePuzzles: PuzzleHeaderDto[]

    puzzleSlots: PuzzleHeaderDto[]
    onChangePuzzleSlots(puzzleSlots: PuzzleHeaderDto[]) : void

    onContinue(): void
}

export const EditEscapeRoomStepTwo: React.FC<Props> = ({
    availablePuzzles, puzzleSlots, onChangePuzzleSlots, onContinue, maxSlots, minSlots
}) => {
    const totalSeconds = puzzleSlots.map((pz) => pz!!.seconds)
        .reduce((acc, a) => acc + a, 0)

    const styles = buttonsStyles()
    const classes = containerStyles()
    const tStyles = textStyles()

    const addPuzzle = (puzzle: PuzzleHeaderDto, seconds: number) => {
        if (puzzleSlots.length === maxSlots) {
            showMessage(`Det maksimale antal opgaver (${maxSlots}) er nået.`, 'warning')
            return
        }

        const newPuzzleSlots = [...puzzleSlots, {
            ...puzzle,
            seconds
        }]
        onChangePuzzleSlots(newPuzzleSlots)
    }

    const removePuzzle = (slotIndex: number) => {
        const newPuzzleSlots = [...puzzleSlots]
        newPuzzleSlots.splice(slotIndex, 1)
        onChangePuzzleSlots(newPuzzleSlots)
    }

    return (
        <div>
            <div className={classes.pageWrapper}>
                <SectionTitle text="Opret Escape Room"/>
                <Grid container>
                    {availablePuzzles.map((pz) => {
                        const selected = !!puzzleSlots.find((s) => s.puzzleId === pz.puzzleId)
                        return (
                            <Grid item xs={12} md={6} lg={4} key={pz.puzzleId}>
                                <PuzzleCardView
                                    puzzle={pz}
                                    selected={selected}
                                    onSelect={(seconds) => addPuzzle(pz, seconds)}/>
                            </Grid>
                        )
                    })}
                </Grid>
            </div>

            <Grid className={classes.selectGrid}>
                <p className={tStyles.chooseTask}>Vælg minimum 2 opgaver
                </p>
                {puzzleSlots.map((slot, index) => {
                    return (
                        <div key={index.toString()} style={{ display: 'flex' }}>
                            <div>
                                <Grid
                                    style={{
                                        width: 150,
                                        height: 150,
                                        borderRadius: 20,
                                        margin: 10,
                                        backgroundImage:
                                            `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)),
                                                 url(${slot.materialImage || map})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'cover',

                                    }}
                                    item>
                                    <span className={tStyles.timeSpan}>
                                        <AccessAlarmOutlined/>
                                        {formatTimeline(slot.seconds)}

                                    </span>
                                    <span className={tStyles.puzzleName}>
                                        {slot?.puzzleId}
                                    </span>

                                </Grid>

                                <p style={{
                                    textAlign: 'center',
                                    color: 'white',
                                    fontWeight: 500,
                                    margin: 0,
                                    paddingTop: 8
                                }}>{index + 1}

                                </p>
                            </div>
                            {slot
                            && (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',

                                }}>
                                    <span
                                        className={styles.unselect}
                                        onClick={() => removePuzzle(index)}>
                                        X
                                    </span>
                                </div>
                            )}
                        </div>

                    )
                })}

                <div style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
                }}>

                    <Button
                        style={{
                            backgroundColor: '#33949E',
                            borderColor: 'white',
                            borderStyle: 'solid',
                            borderWidth: 1,
                            color: 'white',
                            fontSize: 20,
                            minWidth: 200,
                            padding: '12px 40px',
                            borderRadius: 24
                        }}
                        type="button"
                        disabled={puzzleSlots.length < minSlots}
                        onClick={onContinue}>
                        Næste
                    </Button>
                    {!!totalSeconds && (
                        <span style={{ display: 'flex', color: 'white', marginTop: 10 }}>
                            {formatTimeline(totalSeconds)}
                            <AccessAlarmOutlined style={{ color: 'white' }}/>
                        </span>
                    )}
                </div>

            </Grid>
        </div>

    )
}
